import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { __await } from 'tslib';

@Component({
  selector: 'app-thank-you-without-ekyc',
  templateUrl: './thank-you-without-ekyc.component.html',
  styleUrls: ['./thank-you-without-ekyc.component.scss']
})
export class ThankYouWithoutEkycComponent implements OnInit {
  product:string
  CustomerCareEmail: any
  ReferenceNumber: any
  RetrievableEmailLink: any
  isSecondDirector: boolean = false
  SecondDirectorName: any
  Industry: any = ['',''];
  constructor(private router: Router,
    private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
    var data = JSON.parse(sessionStorage.FinalResponse)
    var directorDetails = JSON.parse(sessionStorage.directorDetails)
    if(directorDetails.length>1 && data.IsCorrectionRequried==false){
      this.SecondDirectorName = directorDetails[1].Name
      this.isSecondDirector = true
    }
    if (sessionStorage.MSICList) {
      var MSIC = JSON.parse(sessionStorage.MSICList);
      this.Industry = [MSIC[0], MSIC[1]];
    }
    this.CustomerCareEmail = data.CustomerCareEmail
    this.ReferenceNumber = data.ReferenceNumber
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
    this.product=locStorage.ProductDescription
  }

}
